import React, { useState } from "react";
import { Button, Flex, Modal, Rate } from "antd";
import { CheckOutlined, StarFilled } from "@ant-design/icons";

export default function HotelCard({ hotel }) {
  const [open, setOpen] = useState(false);
  const images = [hotel.image, hotel.image, hotel.image]; // replace with real images
  const [current, setCurrent] = useState(0);

  const nextImage = () => setCurrent((c) => (c + 1) % images.length);
  const prevImage = () =>
    setCurrent((c) => (c - 1 + images.length) % images.length);

  return (
    <>
      <div className="p-4 bg-white rounded-2xl shadow-[0_0px_6px_0px_rgba(0,0,0,0.25)] overflow-hidden hover:shadow-lg transition-all w-full">
        {/* Image */}
        <Flex gap={15}>
          <div
            className="relative cursor-pointer w-[60%]"
            onClick={() => setOpen(true)}
          >
            <img
              src={hotel.image}
              alt={hotel.title}
              className="w-full rounded-2xl h-[120px] object-cover"
            />
          </div>

          {/* Price Section */}
          <Flex vertical justify="space-between" className="w-[40%] py-2">
            <div>
              <div className="text-danger text-lg font-bold">{hotel.price}</div>
              <div className="line-through text-sm font-medium">
                {hotel.oldPrice}
              </div>
            </div>
            <div className="text-[#1E1E1E] text-sm font-medium">
              {hotel.savings}
            </div>
            <div className="text-black/40 text-xs flex items-center gap-1">
              <CheckOutlined className="text-green-500" /> Breakfast Included
            </div>
          </Flex>
        </Flex>
        {/* Details */}
        <div className="pt-6">
          <div className="text-base font-medium leading-tight">
            {hotel.title}
          </div>

          <div className="text-sm font-medium mt-1">
            <span className="text-primary font-medium">{hotel.location}</span> |{" "}
            {hotel.distance}
          </div>

          <div className="text-sm font-medium mt-1">
            Entire Villa | 4 Bedrooms | Sleeps 8 Guests
          </div>

          {/* Rating and Button */}
          <div className="flex justify-between items-center mt-3">
            <div className="flex items-center gap-2 text-sm">
              <Rate
                disabled
                allowHalf
                defaultValue={4.5}
                className="text-primary text-base rounded-0"
              />
              <span className="text-[#1E1E1E] font-medium">4.9 (523)</span>
            </div>
            <Button
              type="danger"
              size="middle"
              className="!h-auto mt-2 text-sm rounded-tl-[12px] rounded-bl-none rounded-tr-none 
              rounded-br-[12px] bg-danger hover:bg-red-700 border-none rounded-md px-6 py-2 text-white w-fit"
            >
              Book Now!
            </Button>
          </div>
        </div>
      </div>

      {/* Modal for Image Slider */}
      <Modal
        open={open}
        footer={null}
        onCancel={() => setOpen(false)}
        centered
        width={800}
        bodyStyle={{ padding: 0 }}
      >
        <div className="relative">
          <img
            src={images[current]}
            alt="hotel"
            className="w-full h-[450px] object-cover rounded-t-xl"
          />
          <button
            onClick={prevImage}
            className="absolute left-4 top-1/2 -translate-y-1/2 bg-black/40 text-white px-3 py-2 rounded-full"
          >
            ‹
          </button>
          <button
            onClick={nextImage}
            className="absolute right-4 top-1/2 -translate-y-1/2 bg-black/40 text-white px-3 py-2 rounded-full"
          >
            ›
          </button>
        </div>
      </Modal>
    </>
  );
}
